'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _weakMap = require('babel-runtime/core-js/weak-map');

var _weakMap2 = _interopRequireDefault(_weakMap);

var _defaultsDeep3 = require('lodash/defaultsDeep');

var _defaultsDeep4 = _interopRequireDefault(_defaultsDeep3);

var _core = require('fine-uploader/lib/core');

var _core2 = _interopRequireDefault(_core);

var _callbackProxy = require('./callback-proxy');

var _callbackProxy2 = _interopRequireDefault(_callbackProxy);

var _callbackNames = require('./callback-names');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callbackProxies = new _weakMap2.default();

var createCallbackProxies = function createCallbackProxies(names) {
  var proxyMap = {};

  names.forEach(function (callbackName) {
    proxyMap[callbackName] = new _callbackProxy2.default(callbackName);
  });

  return proxyMap;
};

var registerOptionsCallbacks = function registerOptionsCallbacks(_ref) {
  var callbacks = _ref.callbacks,
      cbProxies = _ref.cbProxies;

  (0, _keys2.default)(callbacks).forEach(function (callbackName) {
    var callbackProxy = cbProxies[callbackName];

    callbackProxy.add(callbacks[callbackName]);
  });
};

var createFineUploader = function createFineUploader(_ref2) {
  var cbProxies = _ref2.cbProxies,
      options = _ref2.options;

  var optionsCopy = (0, _assign2.default)({ callbacks: {} }, options);

  (0, _keys2.default)(cbProxies).forEach(function (callbackName) {
    var proxy = cbProxies[callbackName];

    optionsCopy.callbacks[callbackName] = proxy.proxyFunction;
  });

  return new _core2.default.FineUploaderBasic(optionsCopy);
};

var normalizeCallbackName = function normalizeCallbackName(name) {
  if (!name.match(/^on[A-Z]/)) {
    return 'on' + name[0].toUpperCase() + name.slice(1);
  }

  return name;
};

var FineUploaderTraditional = function () {
  function FineUploaderTraditional(options) {
    (0, _classCallCheck3.default)(this, FineUploaderTraditional);

    var defaultOptions = {
      autoUpload: true,
      maxConnections: 1,
      retry: {
        enableAuto: false,
        autoAttemptDelay: 5,
        maxAutoAttempts: 4,
        preventRetryResponseProperty: 'preventRetry'
      },
      request: {
        endpoint: '/api/upload'
      },
      chunking: {
        enabled: true,
        mandatory: true,
        partSize: 2000000,
        concurrent: {
          enabled: false
        },
        success: {
          endpoint: '/api/uploaded'
        }
      },
      callbacks: {}
    };

    var allOptions = (0, _defaultsDeep4.default)(options, defaultOptions);
    var callbacks = allOptions.callbacks;


    var optionsSansCallbacks = allOptions;
    delete optionsSansCallbacks.callbacks;
    this.options = optionsSansCallbacks;

    callbackProxies.set(this, createCallbackProxies(_callbackNames.traditional));

    registerOptionsCallbacks({ callbacks: callbacks, cbProxies: callbackProxies.get(this) });

    this.methods = createFineUploader({
      cbProxies: callbackProxies.get(this),
      options: optionsSansCallbacks
    });
  }

  (0, _createClass3.default)(FineUploaderTraditional, [{
    key: 'off',
    value: function off(name, callback) {
      var normalizedName = normalizeCallbackName(name);
      var proxy = callbackProxies.get(this)[normalizedName];

      proxy.remove(callback);
    }
  }, {
    key: 'on',
    value: function on(name, callback) {
      var normalizedName = normalizeCallbackName(name);
      var proxy = callbackProxies.get(this)[normalizedName];

      proxy.add(callback);
    }
  }]);
  return FineUploaderTraditional;
}();

exports.default = FineUploaderTraditional;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/traditional.js
// module id = 257
// module chunks = 1